import { ORDER_APIS } from "@/api_framework/api_config";
import { IOrderManagementCancelReasonResponse } from "@/api_framework/api_modals/Orders";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setCancelResons } from "@/app_redux/reducers/slices/auth/order_management_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useOrderManagementCancelReasonAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    // dispatch(
    //   setLoading({
    //     key: "",
    //     status: true,
    //   })
    // );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(ORDER_APIS?.ORDER_CANCEL_REASON?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IOrderManagementCancelReasonResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setCancelResons({
                data: res.data.data,
              }),
            );
          } else {
            dispatch(
              setCancelResons({
                data: [],
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e)
        });
    } catch (e: any) {
      // toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
